import * as React from "react";
const SvgFiRrHrPerson = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hr-person_svg__a)">
      <path
        fill="#062147"
        d="M9.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M21 3c-1.654 0-3 1.346-3 3v5.184a3 3 0 0 0-.832-.18 3 3 0 0 0-2.173.769l-3.009 2.769c-.083-.084-.16-.172-.247-.253l-2.744-2.525a3 3 0 0 0-2.163-.76c-.29.016-.566.086-.832.18V6c0-1.654-1.346-3-3-3S0 4.346 0 6v10.101c0 2.137.832 4.146 2.343 5.657l1.95 1.95a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.95-1.95A5.96 5.96 0 0 1 2 16.101V6a1.001 1.001 0 0 1 2 0s-.005 8.076 0 8.116c.03.655.285 1.309.746 1.857l2.616 2.721a.999.999 0 1 0 1.441-1.387l-2.571-2.67a1 1 0 0 1 .022-1.305 1 1 0 0 1 .687-.33.97.97 0 0 1 .71.244l2.733 2.516a5.01 5.01 0 0 1 1.615 3.68v3.559a1 1 0 1 0 2 0v-3.559a7 7 0 0 0-.824-3.276l3.163-2.911a.98.98 0 0 1 .72-.253 1 1 0 0 1 .687.33c.16.178.441.88.067 1.254l-2.533 2.634a1 1 0 0 0 1.441 1.386l2.578-2.685c.45-.536.686-1.195.701-1.857.002-.023 0-8.065 0-8.065a1.001 1.001 0 0 1 2 0V16.1a5.96 5.96 0 0 1-1.757 4.243l-1.95 1.95a.999.999 0 1 0 1.414 1.414l1.95-1.95a7.95 7.95 0 0 0 2.343-5.657V6c0-1.654-1.345-3-2.999-3m-10.671 7.274.864.795c.456.42 1.158.42 1.614 0l.834-.767a5.1 5.1 0 0 1 2.338-1.17l.013-.02C15.579 7.33 13.949 6 12.001 6S8.424 7.329 8.01 9.11l.012.019a4.94 4.94 0 0 1 2.308 1.144z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hr-person_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHrPerson;
